import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { FormData, UpdateExternalLinkPayload } from '../../../../common/types';
import { formatFormData } from '../../../../common/utils';
import {
	externalResourcesAddUpdateExperience,
	markAddUpdateExperienceFailed,
} from '../../../../experiences';
import { updateExternalLink as updateExternalLinkService } from '../../../../services/external-link-update-service';
import type { State, Props } from '../../types';

export const EVENT_NAME = 'externalResourceUpdate';

export const updateExternalLink =
	(formData: FormData, linkId: string) =>
	async ({ getState, setState }: StoreActionApi<State>, props: Props) => {
		const { cloudId, projectId, createAnalyticsEvent } = props;

		try {
			setState({
				...getState(),
				isUpdating: true,
			});

			const { finalData, wasLinkPrefixedWithExpectedProtocol, protocolPrefix } =
				formatFormData(formData);
			const { resourceType, link, title, description } = finalData;
			const payload: UpdateExternalLinkPayload = {
				projectId,
				id: linkId,
				resourceType: resourceType.value,
				link,
				title,
				description,
			};

			const updatedLink = await updateExternalLinkService(cloudId, payload);

			const currentState = { ...getState() };
			const newLinks = currentState.links.data.map((linkObj) =>
				linkObj.id === linkId ? updatedLink : linkObj,
			);

			setState({
				...currentState,
				isUpdating: false,
				links: {
					...currentState.links,
					data: newLinks,
					totalSize: currentState.links.totalSize,
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), `${EVENT_NAME} succeeded`, updatedLink.id, {
				resourceType: resourceType.value,
				wasLinkPrefixedWithExpectedProtocol,
				protocolPrefix,
				linksCount: newLinks.length,
			});
			externalResourcesAddUpdateExperience.success();
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...getState(),
				isUpdating: false,
			});

			fireTrackAnalytics(createAnalyticsEvent({}), `${EVENT_NAME} failed`);
			markAddUpdateExperienceFailed(null, error);

			// @ts-expect-error - TS2345 - Argument of type 'false' is not assignable to parameter of type 'string | undefined'.
			throw new Error(false);
		}
	};
